
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "FeedSection": [
      "FeedFolderParcel",
      "FeedNote",
      "FeedUserParcel"
    ],
    "Node": [
      "AccessToken",
      "AccessTokenLog",
      "AssistantReferenceDocument",
      "AssistantReferenceSource",
      "Attachment",
      "AttachmentFilePreview",
      "AttachmentFilePreviewAsset",
      "CoeditRoom",
      "Comment",
      "CommentReply",
      "CustomEmoji",
      "Dashboard",
      "Folder",
      "Group",
      "Note",
      "NoteBrowsingHistory",
      "NoteTemplate",
      "NoteTemplateFolder",
      "Notification",
      "OutgoingWebhook",
      "ReviewableDraftComment",
      "ServiceNotification",
      "SharedNote",
      "User"
    ],
    "SearchableDocument": [
      "Comment",
      "CommentReply",
      "Note"
    ]
  }
};
      export default result;
    